import api from './index';
//
let exports = {};

// 交割单详情
exports.getSelloffDeliveryVoucher = function (params, callback) {
    api.get('/selloff/delivery/voucher/get')
        .params(params)
        .done(callback)
        .go();
};
//  交割单分页列表
exports.getSelloffDeliveryVoucherList = function (data, callback) {
    api.post('/selloff/delivery/voucher/list/get')
        .data(data)
        .done(callback)
        .go();
};
//  交割单条目分页列表
exports.getSelloffDeliveryItemList = function (data, callback) {
    api.post('/selloff/delivery/item/list/get')
        .data(data)
        .done(callback)
        .go();
};
// 交割单修改价格
exports.updateSelloffDeliveryVoucherAmount = function (data, callback) {
    api.post('/selloff/delivery/voucher/amount/update/do')
        .data(data)
        .done(callback)
        .go();
};
// 交割单标为已结算操作
exports.updateSelloffDeliveryVoucherSettleState = function (data, callback) {
    api.post('/selloff/delivery/voucher/settleState/update/do')
        .data(data)
        .done(callback)
        .go();
};
// 交割单验取货码操作
exports.updateSelloffDeliveryVoucherTakenCodeVerified = function (data, callback) {
    api.post('/selloff/delivery/voucher/takenCodeVerified/update/do')
        .data(data)
        .done(callback)
        .go();
};
// 取消变卖交割单
exports.doCancelSelloffDeliveryVoucher = function (data, callback) {
    api.post('/selloff/delivery/voucher/cancel/do')
        .data(data)
        .done(callback)
        .go();
};
// 交割单付款凭证列表
exports.getSelloffDeliveryVoucherRecFileList = function (voucherId, callback) {
    api.get('/selloff/delivery/voucher/recFile/list/get')
        .params({
            voucherId: voucherId
        })
        .done(callback)
        .go();
};
// 保存变卖交割单附件-付款凭证
exports.saveSelloffDeliveryVoucherRecFiles = function (data, callback) {
    api.post('/selloff/delivery/voucher/recFile/save/do')
        .data(data)
        .done(callback)
        .go();
};
// 交割单付款凭证列表
exports.getSelloffDeliveryVoucherRecList = function (voucherId, callback) {
    api.get('/selloff/delivery/voucher/rec/list/get')
        .params({
            voucherId: voucherId
        })
        .done(callback)
        .go();
};
export default exports;



//////////////////
// WEBPACK FOOTER
// ./src/api/selloffDelivery.js
// module id = 155
// module chunks = 0